import { SandboxBooking, SandboxClient, SandboxHostGroup } from '../types';

export const createBookings = (
  clients: SandboxClient[],
  groups: SandboxHostGroup[],
  anchorMs: number
): SandboxBooking[] => {
  return Array.from({ length: 18 }, (_, index) => {
    const from = anchorMs + (index - 6) * 2 * 3600000;
    const status =
      index < 4
        ? 'FINISHED'
        : index === 4
        ? 'CANCELED'
        : index === 5
        ? 'REDEEMED'
        : 'ACTIVE';
    const byClient = index % 4 !== 3;
    const client = byClient ? clients[index % clients.length] : null;
    const group = groups[index % groups.length];
    const firstHost =
      group.id === 1
        ? 9 + (index % 8)
        : group.id === 2
        ? 17 + (index % 8)
        : group.id === 3
        ? 25 + (index % 8)
        : 33 + (index % 4);
    return {
      origin: 'preset',
      id: 200 + index,
      group: `preset:booking-group:${index + 1}`,
      hostIds:
        index % 5 === 0
          ? [firstHost, Math.min(firstHost + 1, 36)]
          : [firstHost],
      byClient,
      client: client
        ? {
            id: client.id,
            uuid: client.uuid,
            nickname: client.nickname,
            phone: client.phone,
          }
        : null,
      from: new Date(from).toISOString(),
      to: new Date(from + ((index % 3) + 1) * 3600000).toISOString(),
      status,
      comment: byClient
        ? `Бронь клиента ${client?.nickname}`
        : `Гостевая бронь ${index + 1}`,
    };
  });
};
